var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg32(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4466_96542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8153 8.68056C17.7733 1.05189 6.23723 1.03867 0.18473 8.68056C-0.108379 9.05059 -0.0459414 9.58825 0.324137 9.88131C0.694215 10.1744 1.23178 10.112 1.52489 9.74191C6.88321 2.97649 17.1086 2.96613 22.4752 9.74191C22.7684 10.1123 23.3061 10.1742 23.6759 9.88131C24.046 9.58816 24.1084 9.05059 23.8153 8.68056Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.09556 11.7715C3.80236 12.1415 3.8646 12.6791 4.23459 12.9723C4.60471 13.2655 5.14223 13.2031 5.43534 12.8332C8.79473 8.59389 15.199 8.58611 18.5646 12.8332C18.8578 13.2032 19.3954 13.2655 19.7653 12.9723C20.1353 12.679 20.1976 12.1415 19.9043 11.7715C15.8604 6.66822 8.1457 6.66044 4.09556 11.7715Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00423 14.8622C7.71126 15.2324 7.77379 15.7699 8.14397 16.0629C8.51414 16.3559 9.0517 16.2933 9.34467 15.9232C10.7005 14.2101 13.2971 14.2072 14.6552 15.9232C14.9482 16.2933 15.4857 16.3559 15.8559 16.0629C16.2261 15.7699 16.2886 15.2324 15.9957 14.8622C13.9558 12.2849 10.0474 12.2808 8.00423 14.8622Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 22.0453C13.1896 22.0453 14.1538 21.0811 14.1538 19.8917C14.1538 18.7022 13.1896 17.738 12.0001 17.738C10.8107 17.738 9.84647 18.7022 9.84647 19.8917C9.84647 21.0811 10.8107 22.0453 12.0001 22.0453Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4466_96542"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg32);
export default __webpack_public_path__ + "static/media/32.4e031126a4b33ac0112bc03d6e9e389d.svg";
export { ForwardRef as ReactComponent };